class UrlManager {

    constructor($) {
        this._pathname = window.location.pathname;
        this._searchParams = UrlManager._parseParams(window.location.search);

        this._$ = $;

        $(document).on('url-manager:push', (event, payload) => {
            this._pushData(payload);
        }).on('url-manager:remove', (event, payload) => {
            this._removeData(payload);
        });

        const self = this;

        window.buildHref = function(params = {}) {
            return self.buildHref(params);
        };

        window.extractFromHref = function(param, defVal = null) {
            return self.extractFromHref(param, defVal);
        };

        window.extractHrefParams = function() {
            return self.extractHrefParams();
        };
    }

    buildHref(params = {}) {
        let rawParams = {...this._searchParams, ...params}

        // filter params
        for(var param in rawParams)
        {
            const value = rawParams[param];

            if( Array.isArray(value) && ! value.length )
            {
                delete rawParams[param];
            }
            else if( typeof value === 'object' )
            {
                let filled = Object.values(value).filter((value) => {
                    return typeof (value === 'number' && ! Number.isNaN(value)) || (typeof value === 'string' && value.trim().length)
                }).length > 0;

                if( !filled )
                {
                    delete rawParams[param];
                }
            }
            else if( typeof value === 'string' && !value.trim().length)
            {
                delete rawParams[param];
            }
            else if( value === null )
            {
                delete rawParams[param];
            }
        }

        return this._buildQueryString(rawParams);
    }

    extractFromHref(param, defVal = null) {
        try
        {
            const params = this.extractHrefParams();
            return param in params ? params[param] : defVal;
        }
        catch(e)
        {
            return defVal;
        }
    }

    extractHrefParams() {
        let params = {};
        let queryString = window.location.search.replace(/^\?/, '');

        if( ! queryString || ! queryString.length )
        {
            return {};
        }

        queryString.split('&').forEach(rawPair => {
            let pair = rawPair.split('=');
            let param = pair.shift();

            params[decodeURI(param)] = pair.shift().split(',');
        });

        return params;
    }

    _buildQueryString(params = {}) {
        let segments = [];

        // sort params...
        Object.keys(params).sort().filter(param => param.length).forEach(param => {
            segments.push( param + '=' + (Array.isArray(params[param]) ? params[param].join(',') : params[param]) );
        });

        return segments.length ? ('?' + encodeURI(segments.join('&'))) : '';
    }

    _pushData(payload = {}) {
        this._searchParams = {...this._searchParams, ...payload};

        return this._replaceCurrent();
    }

    _removeData(payload = []) {
        payload = Array.isArray(payload) ? payload : [payload];

        payload.forEach(value => {
            if(value in this._searchParams)
            {
                delete this._searchParams[value];
            }
        });

        return this._replaceCurrent();
    }

    _replaceCurrent() {
        const queryString = this._buildQueryString(this._searchParams);

        window.history.pushState(
            {},
            document.title,
            this._pathname + queryString
        );
    }

    static _parseParams(params) {
        if( params.match(/^\?/g) !== null )
        {
            params = params.replace(/^\?/g, '');
        }

        let decoded = {};

        params.split('&').forEach(param => {
            const splitted = param.split('=');
            const attr = splitted.shift();
            const value = splitted.shift();

            decoded[ decodeURI(attr) ] = Array.isArray(value) ? value.split(',') : [value];
        });

        return decoded;
    }
}

try {
    (function($) {
        new UrlManager($);
    })(window.jQuery);

} catch(e) { console.log(e); }